import { Status } from '@essent/common';
import { createReducer, on } from '@ngrx/store';

import {
  clearAddressCheck,
  getAddressCheck,
  getAddressError,
  getAddressSuccess,
  type AddressFormState,
} from '../../../old/address-form';

export const initialState: AddressFormState = {
  addressCheck: { status: Status.IDLE },
};

export const addressFormReducer = createReducer(
  initialState,
  on(
    getAddressCheck,
    (state, { postcode, houseNumber, houseNumberAddition }) => ({
      ...state,
      selectedPostalCode: { postcode, houseNumber, houseNumberAddition },
      addressCheck: { status: Status.PENDING },
    })
  ),
  on(getAddressSuccess, (state, { street, city, country }) => ({
    ...state,
    addressCheck: {
      status: Status.SUCCESS,
      data: { street, city, country },
    },
  })),
  on(getAddressError, (state, error) => ({
    ...state,
    addressCheck: {
      status: Status.ERROR,
      error: error.response,
    },
  })),
  on(clearAddressCheck, () => ({
    ...initialState,
  }))
);
